import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchCategoriesTree = async (params) => {
  const path = '/categories/tree/';

  const response = await axiosInstance.get(path, {
    params,
  });
  return response.data;
};

export const useGetCategoriesTree = (params = {}, options = {}) => {
  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [params]);

  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['categories-tree', queryParams],
    queryFn: () => fetchCategoriesTree(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  return {
    categories: data,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
